import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { ensureArray } from 'b2b-apps/shop/common/utils/array/array';
import { ContentEntriesState, ContentEntryType } from 'b2b-apps/shop/content/redux/contentEntries/types';

const getState = (state: State): ContentEntriesState => state.content.contentEntries;

const getEntries = (state: State): ContentEntriesState => getState(state) || {};

const getEntryById = (
  state: State,
  entryId: string,
): RemoteRecord<ContentEntryType> => new RemoteRecord(getEntries(state)[entryId]);

const getEntriesByIds = (
  state: State,
  entriesIds: string[],
): Array<RemoteRecord<ContentEntryType>> => ensureArray(entriesIds).map(
  (entryId: string) => getEntryById(state, entryId),
);

const getPreloadedEntryById = (
  preloadedState: State,
  entryId: string,
): RemoteRecord<ContentEntryType> | null => {
  const entry = getEntryById(preloadedState, entryId);

  if (entry.isLoaded) {
    delete preloadedState.content.contentEntries[entryId];
    return entry;
  }

  return null;
};

export {
  getEntries,
  getEntriesByIds,
  getEntryById,
  getPreloadedEntryById,
  getState,
};
